import React from "react";
import { topMorqueData } from "./marqueData";
import duobleimage from "./images/doubleCourts.png";
import { motion } from "motion/react";
import "./cardmarque.css";
import { useQuery } from "react-query";
import axios from "axios";
import { BASEURL } from "../../../../utils/BaseUrl";
import useGetData from "../../../../hooks/apihooks/useGetData";

const CardBottomMarque = () => {
  const { data, isLoading, isError } = useGetData(
    "about-feedback?order=bottom",
    "getAllbottommarquee"
  );
  return (
    <div className="my-5 container mx-auto overflow-hidden">
      <div className="flex">
        <motion.div
          initial={{ x: "-100%" }}
          animate={{ x: 0 }}
          transition={{ duration: 100, repeat: Infinity, ease: "linear" }}
          className="flex flex-shrink-0 lg:gap-20 lg:mx-10 md:gap-10 sm:gap-10 max-sm:gap-10 md:mx-3 sm:mx-1 max-sm:mx-1 "
        >
          {data?.map((v, i) => {
            return (
              <div key={i} className="h-max cardmarque-box">
                <img src={duobleimage} />
                <div>
                  <p className="px-4 text-lg text-mute-grey">{v.feedback}</p>
                  <div className="flex items-center my-4 px-1">
                    <img
                      src={v?.image_url}
                      className="w-14 h-14 rounded-full object-cover object-center"
                    />
                    <div className="ml-4">
                      <h3 className="font-semibold uppercase text-g-black text-2xl">
                        {v.name}
                      </h3>
                      <p className="uppercase text-md font-semibold text-mute-grey">
                        {v.designation}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </motion.div>
        <motion.div
          initial={{ x: "-100%" }}
          animate={{ x: 0 }}
          transition={{ duration: 100, repeat: Infinity, ease: "linear" }}
          className="flex flex-shrink-0 lg:gap-20 lg:mx-10 md:gap-10 sm:gap-10 max-sm:gap-10 md:mx-3 sm:mx-1 max-sm:mx-1 "
        >
          {data?.map((v, i) => {
            return (
              <div key={v.id} className="h-max cardmarque-box ">
                <img src={duobleimage} />
                <div>
                  <p className="px-4 text-lg text-mute-grey">{v.feedback}</p>
                  <div className="flex items-center my-4 px-1">
                    <img
                      src={v.image_url}
                      className="w-14 h-14 rounded-full object-center object-cover"
                    />
                    <div className="ml-4">
                      <h3 className="font-semibold uppercase text-g-black text-2xl">
                        {v.name}
                      </h3>
                      <p className="uppercase text-md font-semibold text-mute-grey">
                        {v.designation}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </motion.div>
      </div>
    </div>
  );
};

export default CardBottomMarque;
